import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BinderAssembly } from 'src/app/models/binder-assembly.model';

@Component({
    selector: 'app-assembly-card',
    imports: [
        CommonModule,
        CurrencyPipe
    ],
    template: `
  <div class="flex flex-column md:flex-row md:align-items-center md:justify-content-between p-3 border-1 mb-3 surface-card" style="border-radius: 10px;">
            <div *ngIf="assembly">
                <div>
                    <span class="inline-flex justify-content-center align-items-center w-2rem h-2rem border-circle border-1 border-primary-500">
                        <i class="pi pi-file text-yellow-700"></i>
                    </span>
                    <span class="text-yellow-700 font-bold ml-2">{{assembly.Name}}</span>
                </div>
                <p class="text-yellow-700 mt-2 mb-0">{{assembly.Description}}</p>
            </div>
            <div class="flex align-items-center justify-content-between md:justify-content-end mt-3 md:mt-0">
                <span class="font-bold text-sm py-1 px-2" style="border-radius: 10px"></span>
                <div class="text-right ml-3">
                    <span class="text-yellow-700 font-bold">Price: {{assembly?.Price | currency:'USD'}}</span>
                    <p class="text-yellow-700 font-bold">QT: {{assembly?.Quantity || 0}}</p>
                    <p class="mb-0 text-yellow-700">Total: {{ getTotalPrice() | currency:'USD' }}</p>
                </div>
            </div>
</div>
  `,
    styles: [],
    standalone: true
})
export class AssemblyCardComponent {
@Input() assembly: Partial<BinderAssembly> | null = null;

getTotalPrice() {
  if(this.assembly && this.assembly.Price && this.assembly.Quantity) {
    return this.assembly.Price * this.assembly.Quantity;
  }
  return 0;
}
}
